import {Injectable} from '@angular/core';
import {Resolve} from '@angular/router';
import {Observable, of} from 'rxjs';
import {Customer} from '../../../customers/shared/model/customer.model';
import {FacadeService} from '../../service/facade/facade.service';
import {catchError, map} from 'rxjs/operators';

@Injectable()
export class CustomersActiveResolver implements Resolve<Observable<Customer[]>> {
  constructor(private facadeService: FacadeService) {
  }

  resolve(): Observable<Customer[]> {
    return this.facadeService.getAllActiveCustomers().pipe(
      map((data) => data),
      catchError(error => {
        return of({error: error});
      })
    );
  }
}
